import { VivElement, defineComponent } from './base.js';
import { escapeHtml } from '../core/htmlEscape.js';

let fieldSeq = 0;

/**
 * `<viv-field label="E-Mail" type="email" name="email" hint="…" [required] [invalid]></viv-field>`
 * Renders a labelled input. The inner control mirrors relevant attributes and
 * is reachable via the `input` getter for value binding.
 */
export class VivField extends VivElement {
    static get observedAttributes(): string[] {
        return ['label', 'type', 'name', 'placeholder', 'hint', 'value', 'required', 'invalid'];
    }

    private controlEl: HTMLInputElement | null = null;
    private readonly fieldId = `vivField-${++fieldSeq}`;

    protected render(): void {
        const label = this.attr('label');
        const hint = this.attr('hint');
        const type = this.attr('type', 'text');
        const name = this.attr('name');
        const placeholder = this.attr('placeholder');
        const value = this.attr('value');
        const required = this.hasFlag('required');
        const invalid = this.hasFlag('invalid');

        this.className = `vivField${invalid ? ' vivField--invalid' : ''}`;
        this.innerHTML = `
            ${label ? `<label class="vivField__label" for="${this.fieldId}">${escapeHtml(label)}${required ? ' *' : ''}</label>` : ''}
            <input id="${this.fieldId}" class="vivField__control" type="${escapeHtml(type)}"${name ? ` name="${escapeHtml(name)}"` : ''}${placeholder ? ` placeholder="${escapeHtml(placeholder)}"` : ''}${value ? ` value="${escapeHtml(value)}"` : ''}${required ? ' required' : ''} />
            ${hint ? `<span class="vivField__hint">${escapeHtml(hint)}</span>` : ''}`;
        this.controlEl = this.querySelector('input');
    }

    get input(): HTMLInputElement | null {
        return this.controlEl;
    }

    get value(): string {
        return this.controlEl?.value ?? '';
    }

    set value(next: string) {
        if (this.controlEl) this.controlEl.value = next;
    }
}

export function registerVivField(): void {
    defineComponent('viv-field', VivField);
}
